import { EPresenceStatusApi } from '@/shared/enums/presence.enum';

export const PresencesSorted = [
  EPresenceStatusApi.AVAILABLE,
  EPresenceStatusApi.BUSY,
  EPresenceStatusApi.NOT_DISTURB,
  EPresenceStatusApi.ON_A_CALL,
  EPresenceStatusApi.BREAK,
  EPresenceStatusApi.WRAP_UP,
  EPresenceStatusApi.AWAY,
  EPresenceStatusApi.BERIGHTBACK,
  EPresenceStatusApi.OFFLINE,
  EPresenceStatusApi.UNAVAILABLE,
] as string[];
